import React, { Fragment } from 'react';
import { toast, ToastOptions } from 'react-toastify';

export const Toast =
  (func, type) =>
  (name, str, options: ToastOptions = {}): void => {
    func(
      <Fragment>
        <h4 className="Toastify__toast-title">{name}</h4>
        {str}
      </Fragment>,
      {
        autoClose: type !== 'error' && type !== 'warning',
        position: 'bottom-right',
        ...options,
      },
    );
  };

export const ToastError = Toast(toast.error, 'error');
export const ToastInfo = Toast(toast.info, 'info');
export const ToastSuccess = Toast(toast.success, 'success');
export const ToastWarn = Toast(toast.warn, 'warning');

export type ToastTheme = 'regular' | 'halloween' | 'christmas';

export const toastThemes: ToastTheme[] = ['regular', 'halloween', 'christmas'];

export const getSeasonalToastTheme = (date = new Date()): ToastTheme => {
  const month = date.getMonth();
  const day = date.getDate();
  if ((month === 9 && day >= 15) || (month === 10 && day <= 8)) {
    return 'halloween';
  }
  if (month === 11) {
    return 'christmas';
  }
  return 'regular';
};
